import { defineMessages } from '@jutro/locale';

export default defineMessages({

    relatedBy: {
        id: 'gateway.associated.contacts.AccountRelationshipType.Related by',
        defaultMessage: 'Related By'
    }
});
